<template>
  <div style='width: 50%;overflow-y: auto' class='h-100'>
    <transport-record-search
      :carrier-id='tracableInfo.carrier.id'
      v-show="mode === 'record'"
      @onSelect='onTransportRecordSelect'></transport-record-search>
    <div v-show='mode === "detail"'>
      <div class='bg-theme color-white uk-text-center cursor-pointer' style='line-height: 30px' @click='switchMode'>
        <span>&lt;&lt;</span>

        {{ $timetransition(transInfo.start_time) }} - {{ $t('运输') }}
      </div>
      <div class='pd-10 uk-padding-remove-bottom'>
        <el-form>
          <el-form-item :label="$t('开始时间')">
            {{ $timetransition(transInfo.start_time) }}
          </el-form-item>
          <el-form-item :label="$t('结束时间')">
            {{ $timetransition(transInfo.end_time) }}
          </el-form-item>
          <el-form-item>
            <MapTraceFilter :filterOptionList='filterOptionList' @onFilter='onFilter'></MapTraceFilter>
          </el-form-item>
        </el-form>

        <el-steps direction='vertical' :active='detailList.length + 1' v-if='detailList.length'>
          <el-step :title="`${$t('开始运输')} ${$timetransition(transInfo.start_time)}`"></el-step>
          <el-step :title='`${item.name} 已到达 ${$timetransition(item.createTime)}`' :key='item.id'
                   v-for='item in detailList'></el-step>
          <el-step v-if='transInfo.end_time'
                   :title="`${$t('结束运输')} ${$timetransition(transInfo.end_time)}`"></el-step>
        </el-steps>
        <el-empty :image-size='70' v-else></el-empty>
        <el-button type='primary' class='w-100' @click="mode = 'probe'" v-if='detailInfo'>{{ $t('点击查看详细') }}
        </el-button>
      </div>

    </div>

    <!-- 探测历史模式 -->
    <div v-if="mode === 'probe'" style='width:100%;'>
      <div style='background:#344962;color:white;height:30px;line-height: 30px;'
           class='w-100 uk-text-center cursor-pointer' @click="mode = 'detail'">
                    <span>&lt;&lt;&nbsp;</span
                    >{{ $t('返回运输记录详情') }}
      </div>
      <div style='height:calc(100% - 50px);overflow-y: auto;padding: 10px 0'>
        <EquiInfo :detail-info='{carrier:detailInfo}' :extInfo='pointInfo'></EquiInfo>
      </div>
    </div>

  </div>
</template>

<script>
import TransportRecordSearch from '@/pages/business/win/TransportHistory/components/TransportRecordSearch.vue'
import { getTransHistory, getTransReach } from '@/api/modules/transport'
import MapTraceFilter from '@/pages/dataBoard/mapMonitor/components/ArchDetail/trace/components/MapTraceFilter.vue'
import EquiInfo from '@/pages/home/component/Map/component/equiInfo.vue'

export default {
  props: {
    filterOptionList: {},
    mapCom: {},
    tracableInfo: {},
    detailInfo: {},
    pointInfo: {}
  },
  components: {
    EquiInfo,
    MapTraceFilter,
    TransportRecordSearch
  },
  data () {
    return {
      mode: 'record', // record(运输记录) | detail(运输记录详情) | probe(点击记录点展示的探测之)
      transInfo: {},
      detailList: []
    }
  },
  methods: {
    onTransportRecordSelect (data) {
      this.mode = 'detail'
      this.transInfo = data
      getTransReach(data.id).then(({ result }) => {
        this.detailList = result
      })
    },
    switchMode () {
      this.mode = (this.mode === 'detail' ? 'record' : 'detail')
      if (this.mode === 'record') {
        this.detailList = []
      }
    },
    // 过滤触发
    onFilter (data) {
      getTransHistory(this.transInfo.id).then(({ result }) => {
        const trace = this.mapCom.filterTracePoint(result.trace, data.option, data.speed)
        // bus.$emit('onMapTrace', result.trace)
        this.mapCom.renderTransportTrace(trace)
      })
    }
  },
  watch: {
    transInfo () {
      // [AMap removed] lazyAMapApiLoaderInstance.load().then(() => {
      this.onFilter({ option: 'filter_none' })
      // [AMap removed] })
    }
  }
}
</script>
<style scoped lang='scss'>
::v-deep .el-step.is-vertical {
  flex-basis: 40px !important;
}
</style>
